import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";

export const findAllSuperiorDepartment = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
    method: "GET",
  });
};

/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
  return request({
    url: `${baseUrl}/joins-work/v1/dataSource/fields`,
    method: "GET",
  });
};
/**
 * 数据源
 */
export const findDataSourceAll = () => {
  return request({
    url: `${baseUrl}/joins-work/v1/dataSource`,
    method: "GET",
  });
};

export const addCustomerInfo = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile`,
    method: "POST",
    data: params,
  });
};
export const updateCustomer = (params, id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v2/new_customer/updateCustomer?id=${id}`,
    method: "POST",
    data: params,
  });
};
export const downloadExcelV2 = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile/downloadCustomerProfile?` + params,
    method: "POST",
    ContentType: "multipart/form-data",
    responseType: "blob"
  });
};
export const addProject = (params) => {
  return request({
    url: `${baseUrl}/joins-work/v2/engineering-project`,
    method: "POST",
    data: params,
  });
};
export const findProvince = () => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province`,
    method: "GET",
  });
};
export const findCitys = (id) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
    method: "GET",
  });
};
export const findAreas = (id) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
    method: "GET",
  });
};
export const findCustomerInfo = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile?` + params,
    method: "GET",
  });
};

export const findCustomerInfoDownloadExcel = (params) => {
  params = parseParam(params);
  return request({
    url:
      `${baseUrl}/joins-sales-cloud/v1/customer_profile/downloadExcel?` +
      params,
    method: "GET",
  });
};

export const findCustomerInfoDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile/${id}`,
    method: "GET",
  });
};
export const findClassifySelect = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/system_classify/select?` + params,
    method: "GET",
  });
};
export const findStaffSelect = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/stuff/getStaffSelect?` + params,
    method: "GET",
  });
};
export const findProjectSelect = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/project_plan/select?` + params,
    method: "GET",
  });
};
export const findShopInfoSelect = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/getShopInfoSelect?` + params,
    method: "GET",
  });
};

export const updateCustomerInfo = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile`,
    method: "PUT",
    data: data,
  });
};

export const delForceCustomerInfo = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v2/new_customer/force/${ids}`,
    method: "DELETE",
  });
};
export const delCustomerInfo = (deleteOption, ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile/${temp}?option=${deleteOption}`,
    method: "DELETE",
  });
};
// 编辑客户信息
export const editCustomerInfo = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customer_profile`,
    method: "PUT",
    data: data,
  });
};
